import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import getSourceThumbnailQuery from "./query-thumbnail";
import { ThumbnailLiveViewer } from "components/thumbnail";
import { getRefreshedSourceThumbnail } from "config/paths";
import { useAuthDataContext } from "components/auth";

const SourceDataViewer = ({ source, intl, history }) => {
  const { token } = useAuthDataContext();

  const query = useMemo(() => getSourceThumbnailQuery(source.id), [source.id]);

  const handleGetDataFromQuery = data => {
    const thumbnailDate = data && data.sourceThumbnailData ? data.sourceThumbnailData.timestamp : null;
    const thumbnailPath = getRefreshedSourceThumbnail(source.id, token, Date.now());
    return { thumbnailPath, thumbnailDate };
  };

  return (
    <ThumbnailLiveViewer
      center
      query={query}
      getThumbnailDataFromQueryResults={handleGetDataFromQuery}
      showThumbnail={source && source.type === "camera"}
      showThumbnailDate
    />
  );
};

SourceDataViewer.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
};

export default withRouter(injectIntl(SourceDataViewer));
